<template>
    <div>
        <article-box :header="model.heading">
            <ul class="-mx-5">
                <li
                    v-for="element in model.navigationElements"
                    :key="element.id"
                    class="py-2 px-5 navigation"
                >
                    <a
                        :href="element.url"
                        :target="element.target"
                        :title="element.name"
                        :class="element.id === pageId ? 'selected' : ''"
                        class="flex items-center py-4 px-5 -mx-5"
                    >
                        <img
                            v-if="element.image"
                            :src="`${element.image}?width=64&height=56&mode=crop&anchor=middlecenter`"
                            :alt="element.name"
                            class="w-24 h-auto mr-2"
                        />
                        <span class="">
                            <span
                                v-if="element.name"
                                class="block font-bold text-base"
                            >
                                {{ element.name }}
                            </span>
                            <span
                                v-if="element.heading"
                                class="block text-sm font-normal"
                            >
                                {{ element.heading }}
                            </span>
                        </span>
                    </a>
                </li>
            </ul>
        </article-box>
    </div>
</template>

<script>
import ArticleBox from '@/Scripts/components/atoms/ArticleBox/ArticleBox.vue';
export default {
    props: ['model'],
    components: {
        ArticleBox
    },
    data() {
        return {
            pageId: this.$store.getters.getPageId
        };
    }
};
</script>
